import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mtn-sample-store-page',
  templateUrl: './sample-store-page.component.html',
  styleUrls: ['./sample-store-page.component.scss']
})
export class SampleStorePageComponent {

  constructor() {
  }


}
